import { useWaffles } from '@pelotoncycle/waffles';
import { useEffect } from 'react';
export var SyncWafflesNavWithVirtualKeyboard = function SyncWafflesNavWithVirtualKeyboard() {
  var _useWaffles = useWaffles(),
      setNavigationPaused = _useWaffles.setNavigationPaused;

  useEffect(function () {
    document.addEventListener('keyboardStateChange', function (e) {
      var _e$detail;

      setNavigationPaused(e === null || e === void 0 ? void 0 : (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.visibility);
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};